<mat-autocomplete>
  @for (item of items | async; track item) {
  <mat-option [value]="item">
    <div [innerHTML]="item | highlight : value"></div>
  </mat-option>
  }
</mat-autocomplete>
